import React, { useState } from 'react';

const DummyUnsubscribe = () => {
  const [email, setEmail] = useState('');
  const [unsubscribed, setUnsubscribed] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Basic email format validation (very simple)
    if (!email || !email.includes('@')) {
      setError('Please enter a valid email address.');
      return;
    }
    // Clear any previous error and show success
    setError('');
    setUnsubscribed(true);
  };

  if (unsubscribed) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h1 style={styles.heading}>Unsubscribed Successfully</h1>
          <p style={styles.message}>
            {email} has been removed from our mailing list.
          </p>
          <p style={styles.footer}>
            If this was a mistake, you can{' '}
            <a href="/" style={styles.link}>resubscribe</a> or contact support.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.heading}>Unsubscribe</h1>
        <p style={styles.subheading}>
          Enter your email address to unsubscribe from our mailing list.
        </p>

        {error && <div style={{ ...styles.alert, ...styles.error }}>{error}</div>}

        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="email"
            placeholder="your.email@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={styles.input}
          />
          <button type="submit" style={styles.button}>
            Unsubscribe
          </button>
        </form>

      </div>
    </div>
  );
};

// Inline styles – you can move these to a separate CSS file
const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
    padding: '20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    padding: '40px',
    maxWidth: '500px',
    width: '100%',
    textAlign: 'center',
  },
  heading: {
    fontSize: '28px',
    marginBottom: '8px',
    color: '#333',
  },
  subheading: {
    fontSize: '16px',
    color: '#666',
    marginBottom: '30px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    marginBottom: '20px',
  },
  input: {
    padding: '12px 16px',
    fontSize: '16px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    outline: 'none',
  },
  button: {
    padding: '12px 16px',
    fontSize: '16px',
    backgroundColor: '#1562B7',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  alert: {
    padding: '12px 16px',
    borderRadius: '4px',
    marginBottom: '20px',
    fontSize: '14px',
  },
  error: {
    backgroundColor: '#f8d7da',
    color: '#721c24',
    border: '1px solid #f5c6cb',
  },
  message: {
    fontSize: '18px',
    color: '#155724',
    backgroundColor: '#d4edda',
    border: '1px solid #c3e6cb',
    padding: '15px',
    borderRadius: '4px',
    marginBottom: '20px',
  },
  footer: {
    fontSize: '14px',
    color: '#999',
    marginTop: '20px',
  },
  link: {
    color: '#1562B7',
    textDecoration: 'none',
  },
};

export default DummyUnsubscribe;
